import cn from '#/utils/classnames'
import styles from './styles.module.css'

interface BadgeProps {
  className?: string
  text: string
  role: TopHap.UserRole
}

export default function Badge({
  text,
  className,
  role
}: BadgeProps) {
  return (
    <span
      className={cn(
        'items-center ml-1 font-normal tracking-wider align-middle rounded-full box-content px-2.5 text-3xs py-0.5 z-10 leading-3 uppercase',
        { [styles.pro]: role === 'pro' },
        { [styles.expert]: role === 'expert' },
        className
      )}
    >
      {text}
    </span>
  )
}
